import { ref, watch } from 'vue';
import { useFieldsStore } from '@/stores/storeFieldData';

export const useValidation = (modelValue, options = {}) => {

    
    const storeField = useFieldsStore();   

    const isValid = ref(false);
    const isTouched = ref(false);
    const textError = ref(null);
    const formPassword = ref(null);
    
    const validation = (field, rawValue = modelValue.value) => {
        isTouched.value = true;

        if(field === 'firstName'){
            isValid.value = modelValue.value?.trim().length >= 2;
            textError.value = isValid.value ? '' : 'Введите Имя';
            storeField.updateFields('firstName', 'disabledBtn', isValid.value);
        }

        // if(field === 'lastName'){
        //     isValid.value = modelValue.value?.trim().length >= 2;
        //     textError.value = isValid.value ? '' : 'Введите Фамилию';
        //     storeField.updateFields('lastName', 'disabledBtn', isValid.value);
            
        // }

        if(field == 'phone'){  
            const cleanNumber = (rawValue ?? '').replace(/\D/g, '').slice(0, 11);
			isValid.value = cleanNumber.length === 11
			textError.value = isValid.value ? '' : 'Введите номер телефона'
			storeField.updateFields('phone', 'disabledBtn', isValid.value)
		}

        if (field === 'email') {
            const emailPattern = /^(?![._%+\-])([A-Za-z0-9._%+\-]{1,})@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
            isValid.value = emailPattern.test(modelValue.value) && modelValue.value.length >= 5;
            textError.value = isValid.value ? '' : 'Укажите корректный email';
            storeField.updateFields('email', 'disabledBtn', isValid.value);
        }

        if(field === 'rules'){
            isValid.value = modelValue.value;
            storeField.updateFields('rules', 'disabledBtn', isValid.value);
        }

        if(field === 'agreement'){
            isValid.value = modelValue.value;
            storeField.updateFields('agreement', 'disabledBtn', isValid.value);
        }

        if(field === 'advertising'){
            isValid.value = modelValue.value;
            storeField.updateFields('advertising', 'disabledBtn', isValid.value);
        }

        if(field === 'category'){
            isValid.value = modelValue.value !== '';
            storeField.updateFields('category', 'disabledBtn', isValid.value);
        }

        if(field == 'password'){
            const raw = modelValue.value ?? ''; 
            isValid.value = raw.trim().length >= 6;
            formPassword.value = modelValue.value;
            textError.value = isValid.value ? '' : 'Введите пароль не менее 6 символов';
            storeField.updateFields('password', 'disabledBtn', isValid.value);
        }
        if(field == 'passwordRepeat'){
            const raw = modelValue.value ?? ''; 
            const originalPassword = options?.originalPassword?.value || '';
            isValid.value = raw.trim().length >= 6 && raw === originalPassword;
            textError.value = isValid.value ? '' : 'Повторите пароль';
            storeField.updateFields('passwordRepeat', 'disabledBtn', isValid.value);
        }
        if(field === 'confirmationCode'){            
			const innValue = modelValue.value?.toString().trim() || '';
            isValid.value = innValue.length >= 4;
            storeField.updateFields('confirmationCode', 'disabledBtn', isValid.value);            
        }
        if(field === 'message'){
            isValid.value = modelValue.value?.trim().length >= 5;
            textError.value = isValid.value ? '' : 'Введите сообщение';
            storeField.updateFields('message', 'disabledBtn', isValid.value);
        }
    }
   
    return {
        validation,

        isTouched,
        isValid,
        textError,
    }
}